import React, { FC } from 'react';

type PropsT = {
  fill?: string;
};

const PresentationRightArrowIcon: FC<PropsT> = ({ fill = 'white' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M14.5894 11.9996L7.46797 5.11139C7.11041 4.76554 7.11042 4.20483 7.46797 3.85899C7.82553 3.51315 8.40524 3.51315 8.76279 3.85899L16.5316 11.3734C16.8892 11.7193 16.8892 12.28 16.5316 12.6258L8.76279 20.1402C8.40524 20.4861 7.82553 20.4861 7.46797 20.1402C7.11042 19.7944 7.11041 19.2337 7.46797 18.8878L14.5894 11.9996Z"
      fill={fill}
    />
  </svg>
);

export default PresentationRightArrowIcon;
import React, { FC } from 'react';

type PropsT = {
  fill?: string;
};

const PresentationRightArrowIcon: FC<PropsT> = ({ fill = 'white' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M14.5894 11.9996L7.46797 5.11139C7.11041 4.76554 7.11042 4.20483 7.46797 3.85899C7.82553 3.51315 8.40524 3.51315 8.76279 3.85899L16.5316 11.3734C16.8892 11.7193 16.8892 12.28 16.5316 12.6258L8.76279 20.1402C8.40524 20.4861 7.82553 20.4861 7.46797 20.1402C7.11042 19.7944 7.11041 19.2337 7.46797 18.8878L14.5894 11.9996Z"
      fill={fill}
    />
  </svg>
);

export default PresentationRightArrowIcon;
